import { render, staticRenderFns } from "./OrderStatusDashboard.vue?vue&type=template&id=494e322d&scoped=true&"
import script from "./OrderStatusDashboard.vue?vue&type=script&lang=js&"
export * from "./OrderStatusDashboard.vue?vue&type=script&lang=js&"
import style0 from "./OrderStatusDashboard.vue?vue&type=style&index=0&id=494e322d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "494e322d",
  null
  
)

export default component.exports